import commons from '../../../components/commons';
import useBannerNavigation from 'legacyfrontend/hooks/useBannerNavigation';

export default function FullWidthBanner({ data }) {
  const { getNavigationProps } = useBannerNavigation();
  const { banner, categoria } = data;

  const textTest = banner[0].title;
  const textDescription = banner[0].description;
  const imgUrlValidated = commons.imgUrlValidator(banner[0].imageUrl);
  const navigationProps = getNavigationProps(banner[0]);

  return (
    <div className='container mb-8 md:mb-12'>
      <h3 className='fullWidthBanner-title text-gray-600 mb-3'>{categoria.descripcion}</h3>
      <div className='grid  grid-cols-1 '>
        <a
          className='block transition duration-500 shadow-sm hover:shadow-lg'
          href={navigationProps.href}
          target={navigationProps.target}
          rel='noreferrer'
        >
          <div key={textTest} className='banner-container no-video'>
            <img className='FullWidthBanner_img' src={imgUrlValidated} alt='title' />
            <div className='flex justify-between items-center p-3'>
              <div className='text-information'>
                {textTest && !banner[0].mostrarTitulo && (
                  <div className='banner_info-title'>{textTest}</div>
                )}
                {textDescription && !banner[0].mostrarDescripcion && (
                  <div className='banner_info-description '>{textDescription}</div>
                )}
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  );
}
